<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        block
        v-on="on"
      >
        Create
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Banks"
      text="Create payroll bank"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-autocomplete
                v-model="type" 
                v-validate="'required'"
                :error-messages="errors.collect('type')"    
                data-vv-name="type" 
                data-vv-as="type"
                label="Type"
                item-text="name"
                item-value="name"
                :items="types"
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="shiftCode"
                v-validate="'required|isExistingSwiftCode'"
                :error-messages="errors.collect('shiftCode')"
                data-vv-name="shiftCode"                
                data-vv-as="SWIFT code"                
                label="SWIFT Code"
                outlined
                @input="shiftCode = shiftCode.toUpperCase()"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="bankCode"
                label="Bank Code"
                outlined
                @input="bankCode = bankCode.toUpperCase()"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"         
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollBanks: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        dialog: false,        
        progressing: false,       
        name: null,
        shiftCode: null,
        bankCode: null,
        type: null,
        types: [
          'Commercial',
          'DFI',
          'Digital Bank',
          'E-Wallet',
          'Investment',
          'Islamic',
        ],
      }
    },
    watch: {
      dialog (value) {
        if (!value) return       
        this.$validator.reset() 
        let scope = this
        this.name = null
        this.shiftCode = null
        this.bankCode = null
        this.type = null
        
        this.$validator.extend('isExistingSwiftCode', {
          getMessage (field, args) {
            return 'Existing SWIFT code found'
          },
          validate (value, args) {
            return !scope.payrollBanks.some(bank => {
              return bank.shift_code === value
            })
          },
        })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true

            this.$api.payrollBanks().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {      
                  this.$emit('created', res.data)                
                  this.progressing = false
                  this.dialog = false
                }
              })
              .catch((e) => {
                if (e.response.data.status) {
                  this.$snack({ 
                    color: 'error',
                    message: e.response.data.status,
                  })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },   
   
      prepareFormData () {
        return {
          name: this.name,
          shift_code: this.shiftCode,
          bank_code: this.bankCode,
          type: this.type,
        }
      },
    },
  }
</script>
